import { Modal } from "reactstrap";
import { useState } from "react";
import { ImageSizeIcon } from "../../../Shared/SVGs/Shared";
import { X } from "react-feather";

const ImageSizeModal = ({ open, toggle }) => {
  // const [open, setOpen] = useState(true);
  // const toggle = () => {
  //   setOpen(false);
  // };
  const style = {
    color: "#E62580",
  };
  return (
    <Modal
      backdropClassName="back-drop"
      isOpen={open}
      toggle={toggle}
      contentClassName="custom-modals-image"
    >
      <div className="cross">
        <div onClick={toggle}>
          <X size={30} color="black" strokeWidth="1px" />
        </div>
      </div>
      <div className="d-flex justify-content-center mb-4 mt-5">
        {ImageSizeIcon}
      </div>
      <div className="d-flex justify-content-center">
        <div className="modal-text">
          Oops! It seems your image size is too large. Please{" "}
          <span style={style}>upload an image</span> within{" "}
          <span style={style}>9 MB</span>
        </div>
      </div>
    </Modal>
  );
};

export default ImageSizeModal;
